module.exports = __webpack_public_path__ + "img/coaching.25151988.svg";